(function () {

	'use strict';

	/*global $:true */

	let cologicGallery = {

		initGallery: function () {


		},

		//--------------------------------------


        openGallery: function (_elem) {
            let that = this;
            let currentPos = parseInt($(_elem).offset().top);
            let input = JSON.parse($(_elem).attr('data-slideItems'));
            let output = '<div class="galWrapper"><div id="gal' + input.slideId + '" class = "iosSliderGal"><div class = "slider">';
            for(let i in input.slideEl) {
                var slideNr = (parseInt(i) + parseInt(1));
                output += '<div class = "slide item' + slideNr + '"style="background-image:url(\'' + input.slideEl[i] + '\')"></div>';
            }
            output += '</div></div><div class="navButtons"><div class="prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div><div class="next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div></div><div class="exit" onclick="closeSlider(this,' + currentPos + ')"></div></div>';
            $(_elem).parent().parent().parent().parent().parent().parent().parent().children().toggleClass('hideElem');
            $(_elem).parent().parent().parent().parent().parent().parent().parent().prepend(output);
            setTimeout(function () {
                that.initGallerySlider('#gal' + input.slideId);

            }, 300);

		},

        openGalleryBig: function (_elem, _galId, _itemId) {
            let that = this;
            let tempGoTo = 1;
            let bg = '';
            let currentPos = parseInt($(_elem).offset().top);
            let itemNr = $(_elem).attr('data-slideItem');
            let colorClasses = $(_elem).parent().parent().parent().data('colorclass');
            let output = '<div class="galWrapper ' + colorClasses + '"><div id="gal' + _galId + '" class ="iosSliderGal"><div class="slider">';
            $('#' + _galId + ' .thumbItem').each(function (index, value) {
                bg = $(this).data('path');
                bg = bg.replace('thumbs', 'big');
                // itemNr = index;
                itemNr = $(this).attr('data-slideItem');
                if(itemNr == _itemId){
                    tempGoTo = index +1;
                }
                output += '<img class="slide item' + itemNr + '"src="' + bg + '" />';
            });
            output += '</div></div><div class="navButtons" id="navButtons' + _galId + '"><div class="prev"><i class="icon-left-arrow" aria-hidden="true"></i></div><div class="next"><i class="icon-right-arrow" aria-hidden="true"></i></div></div><div class="exit" onclick="cologic.closeGalSlider(this,' + currentPos + ')"><i class="icon-kreuz" aria-hidden="true"></i></div></div>';
            $(_elem).parent().parent().children().toggleClass('hideElem');
            $(_elem).parent().parent().parent().parent().prepend(output);
            setTimeout(function () {
                that.initGallerySlider('#gal' + _galId, tempGoTo,'#navButtons' + _galId,);
            }, 300);
		},

        openGalleryBigFromSlider: function (_elem, _galId, _itemId) {
            let that = this;
            let tempGoTo = 1;
            let bg = '';
            let currentPos = parseInt($(_elem).offset().top);
            let itemNr = $(_elem).attr('data-slideItem');
            let colorClasses = $(_elem).parent().parent().parent().data('colorclass');
            let output = '<div class="galWrapper ' + colorClasses + '"><div id="gal' + _galId + '" class ="iosSliderGal"><div class="slider">';
            $('#' + _galId + ' .thumbItem').each(function (index, value) {
                bg = $(this).data('path');
                bg = bg.replace('thumbs', 'big');
                // itemNr = index;
                itemNr = $(this).attr('data-slideItem');
                if(itemNr == _itemId){
                    tempGoTo = index +1;
                }
                output += '<img class="slide item' + itemNr + '"src="' + bg + '" />';
            });
            output += '</div></div><div class="navButtons"><div class="prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div><div class="next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div></div><div class="exit" onclick="cologic.closeGalSlider(this,' + currentPos + ')"><i class="fa fa-close" aria-hidden="true"></i></div></div>';
            $(_elem).parent().parent().parent().children().toggleClass('hideElem');
            $(_elem).parent().parent().parent().parent().parent().prepend(output);
            setTimeout(function () {
                that.initGallerySlider('#gal' + _galId, tempGoTo);
            }, 300);
		},

        openGalleryInner: function (_elem) {
            let that = this;
            let currentPos = parseInt($(_elem).offset().top);
            let input = JSON.parse($(_elem).attr('data-slideItems'));
            let output = '<div class="galWrapper"><div id="gal' + input.slideId + '" class = "iosSliderGal"><div class = "slider">';
            for(let i in input.slideEl) {
                let slideNr = (parseInt(i) + parseInt(1));
                //var cleanTxt = decodeURI(input.slideTxt[i]);
                let cleanTxt = input.slideTxt[i];
                cleanTxt = decodeURIComponent(cleanTxt.replace(/\+/g, ' '));

                output += '<div class = "slide item' + slideNr + '"style="background-image:url(\'' + input.slideEl[i] + '\')"><p class="tSliderTxt">' + cleanTxt + '</p></div>';
            }
            output += '</div></div><div class="navButtons"><div class="prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div><div class="next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div></div><div class="exit" onclick="cologic.closeSlider(this,' + currentPos + ')"></div></div>';
            $(_elem).parent().parent().parent().parent().parent().parent().parent().children().toggleClass('hideElem');
            $(_elem).parent().parent().parent().parent().parent().parent().parent().prepend(output);
            setTimeout(function () {
                that.initGallerySlider('#gal' + input.slideId);

            }, 300);

        },

		//---------------------------------------------------------

        closeSlider: function (_elem, currentPos) {
            $(_elem).parent().parent().children().toggleClass('hideElem');
            $(_elem).parent().remove();
            this.scrollToY(currentPos);
		},


        closeGalSlider: function (_elem, currentPos) {
            $(_elem).parent().remove();
            $('.hideElem').toggleClass('hideElem');
            this.scrollToY(currentPos);
		},


	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicGallery);
}());